// import type { Route } from "react-resource-router"; // CHANGED: '@atlassian/jira-router';

// CHANGED
// export default function getUFORouteName(route: Route): string {
export default function getUFORouteName(route: string): string {
    // REMOVED
    // if (route.ufoName != null) {
    //     return route.ufoName;
    // }
    // return route.name;

    // Remove slashes from route string, since we are not using "react-resource-router"
    // and route names are not available
    return route.replace(/^\//, "").replace(/\//g, "-");
}
